import { useEffect } from 'react';

export function useEventListener(eventName: string, callback: VoidFunction) {
    useEffect(() => {
        window.addEventListener(eventName, callback);

        return () => {
            window.removeEventListener(eventName, callback);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
